import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function TeachingPedagogy() {
  return (
    <>
      <Header />
      {/* Inner Slider */}
      <section class="inr-header">
        <div class="container">
          <div class="inr-header-content">
            <h1 class="title">Teaching Pedagogy</h1>
            <ul class="breadcrumb">
              <li><NavLink to="/">Home</NavLink></li>
              <li> Teaching Pedagogy</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  Inner Body */}
      <section className="innerBody">
        <div className="container  them-container">
          <div className="row">
            <div className="col-12">
              <h1>Teaching Pedagogy</h1>
            </div>
            <div className="p-2"></div>
            <div class="col-12 ">
              <h3 class="subhead"> Pre-Nursery & Play Group </h3>
              <p><b>Age Group:</b> 2 – 3.6 years<br />
                Our Pre-Nursery program is a vibrant introduction to the world of learning. Designed for little explorers, it focuses on language development, gross and fine motor skills, and building confidence to express thoughts, feelings, and curiosity about the world. Through playful activities, Learn with Fun, Brain Gym exercises, storytelling, and stage activities, children gradually develop social skills, early literacy concepts, and letter formation.
                At this stage, every child blossoms socially, emotionally, and cognitively, forming friendships and gaining the confidence to step into the world of structured learning.</p>

              <h3 class="subhead">Nursery </h3>
              <p>Age Group: 3.6 – 5 years<br />
                The Nursery curriculum at SMNS provides a holistic and engaging learning experience. Children explore the world through role play, dramatic activities, and hands-on experiences, developing skills for reading, writing, decision-making, following directions, and social interaction.<br />
                Daily lessons integrate core subjects—English, Hindi, Math, and G.K.—with art, games, free play, and themed activities, ensuring a well-rounded learning experience. Our curriculum is goal-oriented and age-appropriate, while encouraging open communication with parents to support every child’s unique growth journey.</p>

              <h3 class="subhead">Prep </h3>
              <p>Age Group: 4.6 – 6 Years<br />
                Prep at SMNS is a personalized, fun-filled, and multi-sensory learning journey. Our playway approach allows each child to explore and excel in all areas of development within a broad-based, individualized curriculum.</p>

              <h3 class="subhead">Salient Features:</h3>
              <ul className="checklist">
                <li>Interactive “Determine-and-Learn” Methodology – Every child learns actively and meaningfully.</li>
                <li>Action-Based Learning & Thematic Concepts – Knowledge is built through experience and engagement.</li>
                <li>Individualized Attention – Every child is treated as a unique learner.</li>
                <li>Flexible & Age-Appropriate Activities – Both indoor and outdoor learning opportunities included.</li>
                <li>Integrated Core Curriculum – English, Hindi, Math & EVS blended with creative and fun learning experiences.</li>
              </ul>
              <p>At SMNS Prep, children develop confidence, critical thinking, and a love for learning, preparing them to take on future challenges with curiosity, creativity, and joy.<br />
                Key Philosophy Across All Grades:
                At SMNS, every child is valued, nurtured, and inspired. Our curriculum combines play-based learning, skill development, and moral growth to ensure that children learn with love, confidence, and curiosity—truly reflecting our motto: “Love One Another.”</p>
            </div>
          </div>
        </div>
      </section>
      <div className="clr100"></div>
      {/* Footer */}
      <Footer />
    </>
  )
}

export default TeachingPedagogy